import { useCallback } from 'react';
import { useConsent } from './useConsent';

declare global {
  interface Window {
    ttq: {
      track: (event: string, params?: Record<string, any>) => void;
      page: () => void;
      identify: (params: Record<string, any>) => void;
    };
  }
}

export const useTikTokPixel = () => {
  const { hasAnalyticsConsent } = useConsent();

  const trackEvent = useCallback((eventName: string, params?: Record<string, any>) => {
    if (hasAnalyticsConsent() && typeof window.ttq?.track === 'function') {
      window.ttq.track(eventName, params);
      console.log(`[TikTok Pixel] Tracked: ${eventName}`, params);
    }
  }, [hasAnalyticsConsent]);

  const trackPageView = useCallback(() => {
    if (hasAnalyticsConsent() && typeof window.ttq?.page === 'function') {
      window.ttq.page();
      console.log('[TikTok Pixel] PageView tracked');
    }
  }, [hasAnalyticsConsent]);

  const trackCompleteRegistration = useCallback((userType: 'candidate' | 'company') => {
    trackEvent('CompleteRegistration', {
      content_name: userType === 'candidate' ? 'Kandidaat Account' : 'Bedrijf Account',
    });
  }, [trackEvent]);

  return {
    trackEvent,
    trackPageView,
    trackCompleteRegistration,
  };
};
